<script setup>
import { QuillEditor } from '@vueup/vue-quill';
import ImageUploader from 'quill-image-uploader';
import BlotFormatter from 'quill-blot-formatter';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import FormInputLabel from '@/components/Shared/Form/Input/Label.vue';
import FormInputError from '@/components/Shared/Form/Input/Error.vue';
import { ref } from 'vue';

defineEmits(['update:modelValue']);

const props = defineProps({
  labelText: {
    type: String,
    default: null,
  },
  containerClass: {
    type: String,
    default: '',
  },
  modelValue: {
    type: String,
    default: null,
  },
  error: {
    type: String,
    default: '',
  },
  toolbar: {
    type: Array,
    default: null,
  },
});

const editor = ref(null);

const reset = () => {
  editor.value.setHTML(null);
};

const modules = [
  {
    name: 'imageUploader',
    module: ImageUploader,
    options: {
      upload: file => {
        return new Promise((resolve, reject) => {
          const formData = new FormData();
          formData.append('image', file);

          axios
            .post(route('editor.upload-image'), formData)
            .then(res => {
              resolve(res.data.url);
            })
            .catch(err => {
              reject('Upload failed');
              console.error('Error:', err);
            });
        });
      },
    },
  },
  {
    module: BlotFormatter,
    options: {
      blotFormatter: {},
    },
  },
];

defineExpose({
  reset,
});
</script>

<template>
  <div :class="containerClass">
    <form-input-label v-if="labelText" :for="$attrs.id" :value="labelText" :required="$attrs.required" />

    <QuillEditor
      ref="editor"
      :content="modelValue"
      @update:content="$emit('update:modelValue', $event)"
      content-type="html"
      theme="snow"
      :toolbar="toolbar ?? `full`"
      :modules="modules"
    />

    <!-- A dummy div so the error will display-->
    <div v-if="error" class="is-invalid"></div>

    <form-input-error v-if="error" :error-message="error" />
  </div>
</template>

<style>
.ql-editor {
  overflow-y: scroll;
  min-height: 150px;
}
</style>
